'use strict';

import {oauth} from '../../../services/oauth/oauth';
import {AUTH_COOKIES, set_cookie, delete_cookie} from '../../../services/sessionState/cookies';

const deepLinks: {[goPage: string]: string} = {
    'captable': '/app/captable/summary',
    'filings': '/app/company/settings/?tab=facts',
    'fq': '/app/framable/fq'
};

export class OauthLoginCtrl {
    constructor($routeParams: ng.route.IRouteParamsService) {
        const zephyrCompanyId = <string>$routeParams['company'];

        let redirect = $routeParams['redirect'] || deepLinks[$routeParams['goPage']];

        AUTH_COOKIES.forEach(to_remove => delete_cookie(to_remove));

        if (zephyrCompanyId) {
            set_cookie('zephyr_company', zephyrCompanyId);
        }

        oauth.oAuthConnect('gust', "required", redirect).catch(() => {
            document.location.href = '/login';
        });
    }
}

OauthLoginCtrl.$inject = ['$routeParams'];



// WEBPACK FOOTER //
// ./_src/ui/preLoginApp/login/oauthLogin.ts